import * as ApplicationForCandidacyExamForm from "./ApplicationForCandidacyExam.js";
import * as ExaminationEvaluation from "./ExaminationEvaluation.js";
import { BOOL } from "../../util/constants";
import { inputMappings } from "../../util/enums";

export const formSections = [
  ...ApplicationForCandidacyExamForm.formSections,
  {
    title: "Advisor Approval Info",
    id: "advisor-approval-info",
    questions: [
      {
        id: "waived-oral-exam",
        type: inputMappings.checkbox,
        dataField: "waivedOralExam",
        defaultValue: BOOL.NO,
        choices: [
          {
            id: "waived-oral-exam-yes",
            value: BOOL.YES,
            title: "Waived Oral Exam"
          }
        ]
      },
      {
        id: "second-examination",
        title: "Permitted to take a second examination",
        required: false,
        type: inputMappings.radio,
        dataField: "allowedToTakeSecondExam",
        choices: [
            {
              id: "second-examination-yes",
              title: "Yes",
              value: BOOL.YES,
              branch: "written-exam-accepted"
            },
            {
              id: "second-examination-no",
              title: "No",
              value: BOOL.NO
            }
        ]
      },
      {
        id: "written-exam-accepted",
        title: "Written portion accepted by all committee members as presented",
        dependencies: ["second-examination"],
        required: false,
        type: inputMappings.radio,
        dataField: "writtenExamAccepted",
        choices: [
          {
            id: "written-exam-accepted-yes",
            title: "Yes",
            value: BOOL.YES
          },
          {
            id: "written-exam-accepted-no",
            title: "No",
            value: BOOL.NO
          }
        ]
      }
    ]
  },
  ...ExaminationEvaluation.formSections
];

export const advisorApprovalQuestions = [
  {
    id: "waived-oral-exam",
    type: inputMappings.checkbox,
    dataField: "waivedOralExam",
    defaultValue: BOOL.NO,
    choices: [
      {
        id: "waived-oral-exam-yes",
        value: BOOL.YES,
        title: "Student has waived the right to take the oral portion. Committee members must indicate that this exam is unsatisfactory, and the student must submit a written request for waiver to the Graduate School."
      }
    ]
  },
  {
    id: "second-examination",
    title: "If unsatisfactory, the student is permitted to take a second examination.",
    required: false,
    type: inputMappings.radio,
    dataField: "allowedToTakeSecondExam",
    choices: [
      {
        id: "second-examination-yes",
        title: "Yes",
        value: BOOL.YES,
        branch: "written-exam-accepted"
      },
      {
        id: "second-examination-no",
        title: "No",
        value: BOOL.NO
      }
    ]
  },
  {
    id: "written-exam-accepted",
    title: "If yes, was the written portion accepted by all committee members as presented? Indicating yes means the student will not be required to retake the written portion.",
    dependencies: ["second-examination"],
    required: false,
    type: inputMappings.radio,
    dataField: "writtenExamAccepted",
    choices: [
      {
        id: "written-exam-accepted-yes",
        title: "Yes",
        value: BOOL.YES
      },
      {
        id: "written-exam-accepted-no",
        title: "No",
        value: BOOL.NO
      }
    ]
  }
];
export const gradFacultyRepApprovalSummary = ExaminationEvaluation.Summary;
export const gradFacultyRepApprovalQuestions = ExaminationEvaluation.questions;

export const additionalFilters = [{
    id: "oral-date-after",
    title: "Oral Date After",
    type: inputMappings.date,
    startTime: false,
    endTime: false
  },
  {
    id: "oral-date-before",
    title: "Oral Date Before",
    type: inputMappings.date,
    startTime: false,
    endTime: false
  }
];